import React, { useState, useEffect, useContext } from 'react'
import { useDispatch, useSelector, ReactReduxContext } from 'react-redux'
import * as paymentStatementActions from 'store/modules/paymentStatement/actions'
import { DateTime } from 'luxon'
import get from 'lodash.get'
import { Container, Form, Row, Col, Button, Spinner, Modal } from 'react-bootstrap'
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import ptBR from 'date-fns/locale/pt-BR'
import { processDownload } from '../../../../helpers/download'
import { useLocation } from 'react-router-dom'
import MaskedInput from 'react-maskedinput'
import Typography from 'components/atoms/Typography'
import IconPDF from 'assets/img/icone-pdf.png'
import IconXLS from 'assets/img/icone-xls.png'
import IconXML from 'assets/img/icone-xml.png'
import IconXMLExchange from 'assets/img/icone-xml-exchange.png'
import 'react-datepicker/dist/react-datepicker.css'
import 'styles/datepicker.scss'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import 'styles/responsive-table.scss'
import './DemonstrativoPagamento.scss'
import CustomModal from 'components/molecules/CustomModal'
import { isDebugMode } from 'helpers/tools'

setDefaultLocale('pt-BR')
registerLocale('pt-BR', ptBR)

function DemonstrativoPagamento(props) {
  const { data, user } = props
  const search = useLocation().search
  let login_user = useSelector((state) => state?.auth?.user)
  const uid = login_user?.contract
  const dispatch = useDispatch()
  const { store } = useContext(ReactReduxContext)
  const reportLogs = useSelector((state) => state.paymentStatement.reportLogs)
  const [displayLogs, setDisplayLogs] = useState([])
  const errorPaymentDemonstrative = useSelector(
    (state) => state.paymentStatement.errorPaymentDemonstrative
  )
  const breadcrumb = get(props, 'data.breadcrumb') || []
  const [requestDate, setRequestDate] = useState([])
  const [intervalId, setIntervalId] = useState(null)
  const [datepickerType, setDatepickerType] = useState('day')
  const [startDate, setStartDate] = useState(new Date())
  const [generatingNewDoc, setGeneratingNewDoc] = useState(false)
  const [showError, setShowError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [customInput, setCustomInput] = useState('')
  const [loadingFile, setLoadingFile] = useState('')
  const [debugMode, setDebugMode] = useState(false)

  const token = useSelector(state => state?.token)

  function checkExistingRequest(date, type="day") {
    if(!reportLogs?.logs) {
      return false
    } else {      
      const logs = reportLogs?.logs["processing"].concat(reportLogs?.logs["success"]).concat(reportLogs?.logs["waiting"])
      if(type=="month") {
        return logs.filter((item)=>item.request_date.split(" ")[0]==`${date}-01` && item.request_task.includes(type)).length>0 
      } else {        
        return logs.filter((item)=>item.request_date.split(" ")[0]==date && item.request_task.includes(type)).length>0 
      }  
    }
  }

  function checkProcessingRequest() {    
    if(!reportLogs?.logs) {
      return false
    } else {
      const logs = reportLogs?.logs["processing"].concat(reportLogs?.logs["waiting"])
      return logs.length>0
    }
  }

  function checkRequestNoData(date, type="day") {    
    if(!reportLogs?.logs) {
      return false
    } else {
      const logs = reportLogs?.logs["errors"]
      if(type=="month") {        
        return logs.filter((item)=>item.request_date.split(" ")[0]==`${date}-01` && item.request_task.includes(type) && item?.response?.error.includes('No data found')).length>0 
      } else {        
        return logs.filter((item)=>item.request_date.split(" ")[0]==date && item.request_task.includes(type) && item?.response?.error.includes('No data found')).length>0 
      }
    }
  }

  // function checkNotReady(date, type="day") {    
  //   if(!reportLogs?.logs) {
  //     return false
  //   } else {
  //     const logs = reportLogs?.logs["errors"]
  //     if(type=="month") {        
  //       return logs.filter((item)=>item.request_date.split(" ")[0]==`${date}-01` && item.request_task.includes(type) && item?.response?.error.includes('not ready')).length>0 
  //     } else {        
  //       return logs.filter((item)=>item.request_date.split(" ")[0]==date && item.request_task.includes(type) && item?.response?.error.includes('not ready')).length>0 
  //     }
  //   }
  // }
  
  const handleClose = () => {
    setShowError(false)
    setErrorMessage('')
  }
  const handleShow = () => setShowError(true)

  const generateDocs = (date, retry=null) => {
    if (!date || typeof date !== 'object') {
      setErrorMessage('Data inválida.')
      handleShow()
      setStartDate(Date.now())
      return false
    }
    const dt = new Date(date).toISOString()
    setGeneratingNewDoc(true)
    const type = retry || datepickerType    
    const dateObj = DateTime.fromISO(dt)
    let formattedDate = dateObj.toISODate()
    if(type == 'month') {
      formattedDate = dateObj.toFormat('yyyy-MM')
    }
    if(checkRequestNoData(formattedDate, type)){
      setErrorMessage('Nenhum dado encontrado para a data especificada.')
      handleShow()
      setGeneratingNewDoc(false)
      return false
    }
    if (!checkExistingRequest(formattedDate, type)) {
      setRequestDate([...requestDate, { date: formattedDate, type: type}])
      dispatch(
        paymentStatementActions.generateDocs({ date: formattedDate, datepickerType: type, uid, store, debugMode })
      )
    } else {
      setErrorMessage(<p>Já existe uma solicitação de Demonstrativo de Pagamento disponível para download referente a esta data.</p>)
      handleShow()
      setGeneratingNewDoc(false)
    } 
  }

  const datepickerChanged = () => {
    if (datepickerType === 'month') {
      setDatepickerType('day')
    } else if (datepickerType === 'day') {
      setDatepickerType('month')
    }
  }

  const renderTableItems = (items) => {
    return items.map((item, index) => {
      const dateRequested = get(item,'request_date')
      if (!dateRequested) return ''
      const pdfReport = get(item, 'response.pdf_report')
      const xlsReport = get(item, 'response.xls_report')
      const xmlReport = get(item, 'response.xml_report')
      const xmlReportExchange = get(item, 'response.xml_report_exchange')
      const hasDocument = get(item, 'response.total_time')
      const isError = get(item, 'response.error')
      const dateObj = dateRequested ? new Date(dateRequested) : null
      const isMonth = get(item, 'request_task').includes("month")
      const date =
        isMonth
          ? DateTime.fromISO(dateObj.toISOString()).toFormat('MM/yyyy')
          : DateTime.fromISO(dateObj.toISOString()).toFormat('dd/MM/yyyy')

      return (
        <Tr key={index}>
          <Td className="text-gray-100 payment-statement__report-status">
            {hasDocument ? (
              <div className="payment-statement__available"> Disponível </div>
            ) : (
              isError ? (<div className="payment-statement__loading">
                {isError.includes("Timeout") && (
                  <div className="payment-statement__error"> <i className="icone-alert mr-2" /> Erro</div>
                )}
                {isError.includes("No data") && (
                  <div className="payment-statement__nodata"> <i className="icone-alert mr-2" /> Sem dados</div>                  
                )}
                {isError.includes("not ready") && (
                  <div className="payment-statement__nodata"> <i className="icone-alert mr-2" /> Não baixado</div>                  
                )}
                {(!isError.includes("Timeout") && !isError.includes("No data") && !isError.includes("not ready")) && (
                  <div className="payment-statement__error"> <i className="icone-alert mr-2" /> Erro</div>                 
                )}
              </div>) : (<div className="payment-statement__loading">
                <Spinner animation="border" role="status" size="sm">
                  <span className="sr-only">Processando...</span>
                </Spinner>
                Processando
              </div>)              
            )}
          </Td>
          <Td className="text-gray-100 payment-statement__report-date">{date}</Td>
          <Td className={'text-gray-100'}>
            {isError && (isError.includes("Timeout") || isError.includes("not ready")) ? ( 
              <center>
                <Button              
                variant="outline-primary"
                size="sm"
                onClick={() => { 
                  generateDocs(dateObj, isMonth ? "month" : "day")
                }}
                disabled={generatingNewDoc}>
                  Gerar novamente{' '}
                  {generatingNewDoc && <Spinner className="ml-2" animation="border" role="status" size="sm" />}
                </Button>
              </center>
            ) : (
              <div className={'payment-statement__report'}>
                {(!loadingFile || loadingFile != pdfReport) && (
                  <Button
                    className={`${pdfReport ? 'payment-statement__report--done' : ''}`}
                    title="Baixar relatório em PDF"
                    variant="link"
                    disabled={!pdfReport}
                    onClick={() => processDownload(token, `/api/v1/payment/file/${pdfReport}`, pdfReport, setLoadingFile)}
                  >
                    <img src={IconPDF} alt="ícone de representação de um arquivo PDF" />
                  </Button>
                )}
                {loadingFile != '' && loadingFile == pdfReport && (
                  <Spinner animation="border" size="sm" className="d-flex" />
                )}
                {(!loadingFile || loadingFile != xlsReport) && (
                  <Button
                    className={`${xlsReport ? 'payment-statement__report--done' : ''}`}
                    title="Baixar relatório em XLS"
                    variant="link"
                    disabled={!xlsReport}
                    onClick={() => processDownload(token, `/api/v1/payment/file/${xlsReport}`, xlsReport, setLoadingFile)}
                  >
                    <img src={IconXLS} alt="ícone de representação de um arquivo XLS" />
                  </Button>
                )}
                {loadingFile != '' && loadingFile == xlsReport && (
                  <Spinner animation="border" size="sm" className="d-flex" />
                )}
                {(!loadingFile || loadingFile != xmlReport) && (
                  <Button
                    className={`${xmlReport ? 'payment-statement__report--done' : ''}`}
                    title="Baixar relatório em XML"
                    variant="link"
                    disabled={!xmlReport}
                    onClick={() => processDownload(token, `/api/v1/payment/file/${xmlReport}`, xmlReport, setLoadingFile)}
                  >
                    <img src={IconXML} alt="ícone de representação de um arquivo XML" />
                  </Button>
                )}
                {loadingFile != '' && loadingFile == xmlReport && (
                  <Spinner animation="border" size="sm" className="d-flex" />
                )}
                {(!loadingFile || loadingFile != xmlReportExchange) && (
                  <Button
                    className={`${xmlReportExchange ? 'payment-statement__report--done' : ''}`}
                    title="Baixar relatório em XML Intercâmbio"
                    variant="link"
                    disabled={!xmlReportExchange}
                    onClick={() =>
                      processDownload(token, `/api/v1/payment/file/${xmlReportExchange}`, xmlReportExchange, setLoadingFile)
                    }
                  >
                    <img src={IconXMLExchange} alt="ícone de representação de um arquivo XML" />
                  </Button>
                )}

                {loadingFile != '' && loadingFile == xmlReportExchange && (
                  <Spinner animation="border" size="sm" className="d-flex" />
                )}
              </div>
            )}
          </Td>          
        </Tr>
      )
    })
  }

  useEffect(() => {
    if (errorPaymentDemonstrative) {
      setErrorMessage(errorPaymentDemonstrative)
      handleShow()
      setGeneratingNewDoc(false)
    }
  }, [errorPaymentDemonstrative])

  useEffect(() => {    
    dispatch(        
      paymentStatementActions.getReportLogs({ userCode: login_user?.contract, store, debugMode })
    )    
    const { host = '', search = '' } = window?.location || {}
    const isDebugModeTemp = isDebugMode({ host, search })
    setDebugMode(isDebugModeTemp)
  }, [])

  useEffect(() => {
    
    if(requestDate.length>0){
      for(const i in requestDate){
        // if(checkRequestNoData(requestDate[i].date, requestDate[i].type)){
        //   setErrorMessage('Nenhum dado encontrado para a data especificada.')
        //   handleShow()
        //   setRequestDate(requestDate.filter(req=>req!=requestDate[i]))
        //   setGeneratingNewDoc(false)
        // }
        // if(checkNotReady(requestDate[i].date, requestDate[i].type)){
        //   setErrorMessage('Pagamento não baixado. Tente novamente mais tarde.')
        //   handleShow()
        //   setRequestDate(requestDate.filter(req=>req!=requestDate[i]))
        //   setGeneratingNewDoc(false)
        // }
        if(checkExistingRequest(requestDate[i].date, requestDate[i].type)) {
          setGeneratingNewDoc(false)
        }
      }
    }
    function checkStatusEveryNSeconds() {
      dispatch(
        paymentStatementActions.getReportLogs({ userCode: login_user?.contract, store, debugMode })
      )
    }

    if (intervalId) {
      clearInterval(intervalId)
    }

    if(checkProcessingRequest()){
      const INTERVAL = 15000 // 15s
      setIntervalId(setInterval(checkStatusEveryNSeconds, INTERVAL))
    }

    if(reportLogs?.logs) {
      const logs = reportLogs.logs["processing"].concat(reportLogs.logs["success"]).concat(reportLogs.logs["waiting"]).concat(reportLogs.logs["errors"])
      setDisplayLogs(logs)
    }

    return function cleanup() {
      clearInterval(intervalId)
    }    
  }, [reportLogs])

  const handleDateChange = (date) => {
    setStartDate(date)
  }

  const handleDateChangeBlur = (e) => {
    setCustomInput('')
    if (e.target.value) {
      validateSelectedDay(e.target.value)
    }
  }

  const handleMonthChangeBlur = (e) => {
    setCustomInput('')
    if (e.target.value) {
      validateSelectedDay('01/' + e.target.value)
    }
  }

  const validateSelectedDay = (dateStr) => {
    let dateParts = dateStr.split('/')
    const date = new Date(dateParts[2], parseInt(dateParts[1]) - 1, dateParts[0])
    const result = DateTime.fromJSDate(date).toFormat('dd/MM/yyyy')
    if (dateStr != result) {
      setStartDate(new Date())
      setErrorMessage('Data inválida.')
      handleShow()
    } else {
      const currentDate = new Date()
      let d1 = DateTime.fromJSDate(date).toFormat('yyyy-MM-dd')
      let d2 = DateTime.fromJSDate(currentDate).toFormat('yyyy-MM-dd')
      if (d1 > d2) {
        setStartDate(new Date())
        setErrorMessage('Data inválida, não é possível consultar uma data futura.')
        handleShow()
      }
    }
  }

  const handleFocus = () => {
    const maskedInput =
      datepickerType == 'day' ? (
        <MaskedInput mask="11/11/1111" placeholder="dd/mm/yyyy" size="20" />
      ) : (
        <MaskedInput mask="11/1111" placeholder="mm/yyyy" size="20" />
      )
    setCustomInput(maskedInput)
  }

  return (    
    <Container className="mt-5 mb-5">
      <Row>
        <Col>
          <Typography variant="h2" color="primary" cssClass="title-semibold-md payment-statement__title mb-3">
            {data.title}
          </Typography>

          <div className="bg-green-dark-100">
            <Typography variant="p" color="white" cssClass="p-2 uppercased">
              {login_user?.name}
            </Typography>
            <Typography variant="p" color="white" cssClass="p-2 uppercased payment-statement__code">
              Código Unimed: {login_user?.contract}
            </Typography>
          </div>

          <Typography cssClass="mb-3 mt-4" variant="p" color="gray-100">
            Selecione se o demonstrativo será referente a uma data ou competência:
          </Typography>

          <div className="payment-statement__compentence-selector mt-3 mb-4" style={{ display: 'flex' }}>
            <label className={datepickerType === 'day' ? 'active' : ''}>Data: (dd/mm/aaaa)</label>
            <Form.Check
              className={datepickerType === 'month' ? 'active ml-2' : 'ml-2'}
              type="switch"
              id="custom-switch"
              label="Competência: (mm/aaaa)"
              onChange={(e) => datepickerChanged(e.target.value)}
            />
          </div>

          <Typography id="date" cssClass="mb-3" variant="p" color="gray-100">
            Informe uma {datepickerType === 'month' ? 'competência' : 'data'} para a consulta e clique em "Gerar
            documentos":
          </Typography>

          {datepickerType === 'day' ? (
            <DatePicker
              dateFormat="dd/MM/yyyy"
              selected={startDate}
              onChange={(date) => handleDateChange(date)}
              onBlur={(e) => handleDateChangeBlur(e)}
              onClickOutside={(e) => handleDateChangeBlur(e)}
              onFocus={() => handleFocus()}
              customInput={customInput}
              title="Dia"
              ariaLabelledBy="date"
            />
          ) : (
            <DatePicker
              selected={startDate}
              onChange={(date) => handleDateChange(date)}
              dateFormat="MM/yyyy"
              Tilte
              showMonthYearPicker
              showFullMonthYearPicker
              onBlur={(e) => handleMonthChangeBlur(e)}
              onClickOutside={(e) => handleMonthChangeBlur(e)}
              onFocus={() => handleFocus()}
              customInput={customInput}
              title="Mês"
              ariaLabelledBy="date"
            />
          )}

          <Button
            className="mt-4 mb-5"
            variant="outline-primary"
            size="lg"
            onClick={() => generateDocs(startDate)}
            disabled={generatingNewDoc}
          >
            Gerar documentos{' '}
            {generatingNewDoc && <Spinner className="ml-2" animation="border" role="status" size="sm" />}
          </Button>

          <CustomModal
            open={showError}
            closeModal={() => handleClose()}
            size="sm"
            title="Demonstrativo de Pagamentos"
            footer={{
              closeButton: true,
            }}
          >
            <p className="p-3">
              <strong>{errorMessage}</strong>
            </p>
          </CustomModal>
        </Col>
      </Row>

      {displayLogs.length > 0 && (
        <Row>
          <Col>
            <Table className="responsive-table payment-statement__process">
              <Thead>
                <Tr>
                  <Th>Status</Th>
                  <Th>Data</Th>
                  <Th className="text-center">Documentos</Th>
                </Tr>
              </Thead>

              <Tbody>{renderTableItems(displayLogs)}</Tbody>
            </Table>
          </Col>
        </Row>
      )}
    </Container>
  )
}

export default DemonstrativoPagamento
